"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var EmbedPresetsWidgetContext_1 = require("./EmbedPresetsWidgetContext");
var EmbedWidget_1 = __importDefault(require("../EmbedWidget/EmbedWidget"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Types_1 = require("@CommonFrontend/Tokens/Types");
var widgetEventHelperFunctions_1 = require("./widgetEventHelperFunctions");
var EmbedPresetsWidgetMenu_1 = __importDefault(require("./EmbedPresetsWidgetMenu"));
var EnterEmbedCode_1 = __importDefault(require("./EnterEmbedCode"));
var ChooseSource_1 = __importDefault(require("./ChooseSource"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./EmbedPresetsWidget.css"));
var CloseButton = function (_a) {
    var onClose = _a.onClose;
    return (react_1.default.createElement(kaleidoscope_1.IconButton, { onClick: onClose, icon: react_1.default.createElement(icons_1.Close, null), className: styles.closeButton, isIconOnly: true, size: kaleidoscope_1.ButtonSize.Small }));
};
var EmbedPresetsWidget = function (_a) {
    var props = __rest(_a, []);
    var instructions = props.enableTokens === Types_1.TokensEnableState.EnabledWithAllInteractions
        ? "Drag a token in, or type a token name above"
        : "Type a token name above";
    var variableDetails = {
        variable: props.variable,
        instructions: instructions,
        icon: icons_1.Api,
    };
    var widgetManager = props.widgetManager, telemetry = props.telemetry, embedUrl = props.embedUrl, isSelected = props.isSelected, toolbarBeingUsed = props.toolbarBeingUsed, element = props.element, alignment = props.alignment, width = props.width;
    var triggerWidgetFunc = function (eventData) { return (0, widgetEventHelperFunctions_1.triggerWidgetEvent)(eventData, widgetManager); };
    var setAlignmentFunc = function (alignment) { return (0, widgetEventHelperFunctions_1.setAlignment)({ alignment: alignment, widgetManager: widgetManager, element: element }); };
    return (react_1.default.createElement("div", { className: "iframe-widget" },
        react_1.default.createElement(EmbedPresetsWidgetContext_1.EmbedPresetsWidgetContextProvider, __assign({}, props),
            react_1.default.createElement(EmbedPresetsWidgetContext_1.EmbedPresetsWidgetContextConsumer, null, function (_a) {
                var currentStep = _a.currentStep, showPresetsOverlay = _a.showPresetsOverlay, setShowPresetsOverlay = _a.setShowPresetsOverlay, mode = _a.mode, setMode = _a.setMode, setStep = _a.setStep;
                return (react_1.default.createElement(EmbedWidget_1.default, __assign({}, props, { placeholder: currentStep === EmbedPresetsWidgetContext_1.EmbedStep.EnterEmbedCode ? (react_1.default.createElement(EnterEmbedCode_1.default, { embedUrl: embedUrl, closeButton: showPresetsOverlay && react_1.default.createElement(CloseButton, { onClose: function () { return setShowPresetsOverlay(false); } }) })) : (react_1.default.createElement(ChooseSource_1.default, { closeButton: showPresetsOverlay && react_1.default.createElement(CloseButton, { onClose: function () { return setShowPresetsOverlay(false); } }) })), embedType: "iframe", isSelected: isSelected || toolbarBeingUsed, triggerWidgetEvent: triggerWidgetFunc, embedUrl: mode === "url" ? embedUrl : undefined, displayUrl: embedUrl, key: embedUrl, minWidthPx: 128, minHeightPx: 128, placeholderText: "Paste a link to embed https://... ", errorMsg: "Sorry, that doesn't seem to be a valid embed URL. Double check the value and try again.", allowVariables: props.enableTokens !== Types_1.TokensEnableState.Disabled, variableDetails: variableDetails, telemetry: telemetry, showPlaceholderAsOverlay: showPresetsOverlay, showPlaceholderInsteadOfTokenDropArea: mode === "url", menu: function (ref) { return (react_1.default.createElement(EmbedPresetsWidgetMenu_1.default, { showMenu: isSelected || toolbarBeingUsed, handleDelete: function () { return (0, widgetEventHelperFunctions_1.deleteWidget)({ widgetManager: widgetManager, element: element }); }, setAlignment: setAlignmentFunc, hasEmbedUrl: !!embedUrl, alignment: alignment, disableLeftAlignment: width === "wide" || width === "full", allowVariables: props.enableTokens !== Types_1.TokensEnableState.Disabled, token: variableDetails.variable, setToken: function (token) {
                            (0, widgetEventHelperFunctions_1.setToken)({ token: token, widgetManager: widgetManager, element: element });
                            setStep(EmbedPresetsWidgetContext_1.EmbedStep.ChooseSource);
                        }, removeToken: function () {
                            (0, widgetEventHelperFunctions_1.removeToken)({ widgetManager: widgetManager, element: element });
                            setMode("url");
                        }, anchorRef: ref })); } })));
            }))));
};
exports.default = EmbedPresetsWidget;
